import api from "@/lib/api";

export type PostApplicationContractRequest = {
  setupIntentId: string;
  clientSecret: string;
  paymentType: "card" | "billing";
};

export type PostApplicationContractResponse = {
  status: string;
  contractNumber: string;
  isContractActive: boolean;
};

export type ErrorResponse = {
  status: string;
  messageType: string;
  errorCode: string;
};

export default {
  postApplicationContract(data: PostApplicationContractRequest) {
    return api<
      PostApplicationContractRequest,
      PostApplicationContractResponse | ErrorResponse
    >({
      endpoint: "application/web-api/contract",
      method: "POST",
      body: data
    });
  }
};
